module.exports = __webpack_public_path__ + "static/WhenThePastWasAround0-19e7456178ac27a88ffbc773e916d49a.webp";